import './patientOrderHistoryTable.scss';
import React from 'react';
import {ITableColumn} from "../../../../../shared/models/table.model";
import {ITestOrder} from '../../../../../shared/models/testOrder.model';
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import {CommonService} from "../../../../../shared/services";
import {IPatient} from "../../../../../shared/models/patient.model";
import {Link} from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TooltipComponent from "../../../../../shared/components/tooltip/tooltipComponent";
import {APIConfig} from "../../../../../constants";
import TableWrapperV2Component
    from "../../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import commonService from "../../../../../shared/services/common.service";


interface PatientOrderHistoryTableComponentProps {
    filterdata: string;
}

const PatientOrderHistoryTableComponent = (props: PatientOrderHistoryTableComponentProps) => {

    const {filterdata} = props;

    const columns: ITableColumn[] = [
        {
            id: 'priorityIcon',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            width:'50',
            align: 'center',
            fixed: "left",
            content: (item: ITestOrder, index: any) => (
                <React.Fragment>
                    {item?.isPriorityOrder && <ReportProblemIcon color={"primary"}/>}
                </React.Fragment>
            )

        },
        {
            id: 'code', label: 'Order ID',
            isDefaultColumn: true,fixed: 'left',
            width: '150',
            content: (item: ITestOrder) => (
                <div className="text-uppercase">
                    {item?.code || '-'}
                </div>
            )
        },
        {
            id: 'orderingProvider', label: 'Ordering Provider',
            isDefaultColumn: true,width: '200',
            content: (item: ITestOrder) => (
                <>
                    {
                        item?.physicianDetails ?
                            <>
                                {
                                    (item?.physicianDetails?.firstName + " " + item?.physicianDetails?.lastName + " " + item?.physicianDetails?.middleName).length > 30 ?
                                        <TooltipComponent
                                            tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.middleName) + " " + CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName)}
                                            arrow={true}
                                            placement={"top"}>
                                            <div className={"ellipses-for-table-data"}>
                                                Dr.{CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) || '-'} {item?.physicianDetails?.middleName} {CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName)}
                                            </div>
                                        </TooltipComponent> :
                                        <>
                                            Dr. {CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) || '-'} {item?.physicianDetails?.middleName} {CommonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName)}
                                            <br/>
                                        </>
                                }

                                NPI: {item?.physicianDetails?.npiNumber || '-'}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'tests', label: 'Ordered Tests', align: 'center',
            isDefaultColumn: true,
            content: (item: ITestOrder) => {
                const tests = item?.tests.map((test:any) => {
                    return {title: test.code};
                });
                return <>
                    {
                        tests.length > 0 ?
                            <>
                                {
                                    tests?.map((test:any, index:number) => CommonService.capitalize(test.title)).join(', ').length > 10 ?
                                        <TooltipComponent
                                            tooltip={
                                                <div className={'pdd-right-15 pdd-top-5 pdd-bottom-5'}>
                                                    {tests?.map((test:any) => {
                                                            return <>{CommonService.capitalize(test.title)}<br/></>;
                                                        }
                                                    )}
                                                </div>}
                                            arrow={true}>
                                            <div className={'ellipses-for-table-data-tests'}>
                                                {tests?.map((test:any) => CommonService.capitalize(test.title)).join(', ')}
                                            </div>
                                        </TooltipComponent> :
                                        <>
                                            {tests?.map((test:any) => CommonService.capitalize(test.title)).join(', ')}
                                        </>
                                }
                            </> :
                            <> - </>
                    }
                </>
            }
        },
        {
            id: 'orderedDate', label: 'Ordered Date',align:'center',
            isDefaultColumn: true,
            content: (item: ITestOrder) => (
                <>
                    {
                        item?.orderPlacedTime ?
                            <>
                                {commonService.formatDate(item?.orderPlacedTime)}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'status', label: 'Order Status', isDefaultColumn: true,width:'150',align: 'center',
            content: (item: ITestOrder) => (
                <>
                    <ChipComponent className={`min-width-80 ${item?.statusObj?.code}`}
                                   label={CommonService.capitalizeFirstLetter(item?.statusObj?.title)}
                                   />
                </>
            )
        },
        {
            id: 'facility', label: 'Facility',
            isDefaultColumn: true,
            content: (item: ITestOrder) => (
                <>
                    {(item?.facilityDetails && CommonService.capitalizeFirstLetter(item?.facilityDetails?.name)) || '-'}
                </>
            )
        },
        {
            id: 'location', label: 'Location',
            isDefaultColumn: true,
            content: (item: ITestOrder) => (
                <>
                    {(item?.locationDetails && CommonService.capitalizeFirstLetter(item?.locationDetails?.name)) || '-'}
                </>
            )
        },
        {
            id: 'actions',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            fixed: "right",
            width: "100",
            align: 'center',
            content: (item: IPatient, index: any) => (
                <React.Fragment>
                    <div className="table-actions" id={`view_testOrder_` + index}>
                        <Link to={CommonService._routeConfig.TestOrderDetailsRoute(item?.id)}>
                            <div className="table-action">
                                <ChevronRightIcon/>
                            </div>
                        </Link>
                    </div>
                </React.Fragment>
            )
        },
    ];

    return (
        <div className="page-data-wrapper t-table-inside-details">
            <TableWrapperV2Component
                url={APIConfig.TEST_ORDER_LIST.URL}
                method={APIConfig.TEST_ORDER_LIST.METHOD}
                extraPayload = {filterdata}
                isPaginated={true}
                columns={columns}
                isHoverable={true}
                isColumnFilterVisible={false}
            />
        </div>
    )
}
export default PatientOrderHistoryTableComponent;
